import React from 'react';
import { Link } from 'react-router';
import CreateIdeaButton from './CreateIdeaButton';
import {INITIATIVE_TYPE, CIP_TYPE} from '../../constants';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';


const btnIconStyle = {width : '32px'};
const textStyle = {fontSize : '14px', marginTop : '12px'};


class CreateIdeasHeader extends React.Component {

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    return (
      <div className="row" >
          <div className="col-md-4" style={{paddingTop : '10px'}}>
            <CreateIdeaButton to="/ideas/1" title={t('CREATE INITIATIVE')} icon="/images/ideas.png" iconStyle={btnIconStyle} textStyle={textStyle} className={ this.props.ideaType == INITIATIVE_TYPE ? 'selected' : ''}/>
          </div>
          <div className="col-md-4" style={{paddingTop : '10px'}}>
            <CreateIdeaButton to="/ideas/2" title={t('CREATE CONTINUOUS IMPROVEMENT')}  icon="/images/cip.png" iconStyle={btnIconStyle} textStyle={textStyle} className={this.props.ideaType == CIP_TYPE ? 'selected' : ''}/>
          </div>
          <div className="col-md-4">
            
          </div>
        </div>
    );
  }
}

CreateIdeasHeader.displayName = 'CreateIdeasHeader';
CreateIdeasHeader.propTypes = {};
CreateIdeasHeader.defaultProps = {};

export default injectIntl(CreateIdeasHeader);


// WEBPACK FOOTER //
// ./components/Shared/CreateIdeasHeader.js